export enum TRANSLATION_CODES {
  CreateTitleCode = 'admin.printTemplates.modal.createTemplate',
  CreateSelectCode = 'admin.printTemplates.modal.dataSet',
  DuplicateTitleCode = 'admin.printTemplates.modal.duplicateTemplate',
  DuplicateSelectCode = 'admin.printTemplates.modal.template'
}
